import React from 'react';
import './index.css'
import iconCamera from './img/icon-camera.png'
import { Link } from 'react-router-dom'
import { Input, Button } from 'antd';
import { connect } from 'react-redux'
import axios from 'axios'
import store from '../../../../../../store'
import { message } from 'antd';
import { ChangeRoom, DeleteFriend, SaveUser } from '../../../../../../store/actionCreators'
import icon_back from './img/icon-back.png'
import { loadUserLocal } from 'src/service/loginaction_yunguan'
import { glob } from 'fs';

class ChangePersonalInfo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            eMail: this.props.user.email,
            company: this.props.user.company,
            duty: this.props.user.duty,
            cellphone: this.props.user.cellphone,
            avatarUrl: this.props.user.avatar,
            realName: this.props.user.realName
        }
    }

    componentDidMount() {
        // console.log(this.props)
        this.getUserOtherInfo();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.user !== prevProps.user) {
            this.getUserOtherInfo();
            this.setState({
                eMail: this.props.user.email,
                company: this.props.user.company,
                duty: this.props.user.duty,
                cellphone: this.props.user.cellphone,
                avatarUrl: this.props.user.avatar,
                realName: this.props.user.realName
            })
        }
    }

    inputValueChange = (event, flag) => {
        switch (flag) {
            case 1:
                this.setState({
                    company: event.target.value
                })
                break;
            case 2:
                this.setState({
                    duty: event.target.value
                })
                break;
            case 3:
                this.setState({
                    cellphone: event.target.value
                })
                break;
            default:
                break;
        }
    }

    hanleClick = async () => {
        let params = {
            name: this.props.user.toJS().username,
            oldpassword: "",
            password: "",
            cellphone: this.state.cellphone,
            company: this.state.company,
            duty: this.state.duty,
        };

        const { data: res } = await axios.post('http://192.168.158.14:10683/omas/user/profile', params, { withCredentials: false })
        //54接口还有问题，还需要和运管协调
        console.log(res)
    }
    //获取用户资料————用户其他信息
    getUserOtherInfo = () => {
        const { user } = this.props;
        if (!user.username || user.username === undefined || user === {}) return;
        // console.log("getUserOtherInfo-----findprofile-----user", user);
        axios.get(`/yunguanLoginInfoUrl/omas/user/findprofile?username=${user.username}`,
        ).then(res => {
            // console.log("getUserOtherInfo-----findprofile", res.data)
            if (res.data.code === 1) {
                let data = res.data.data;
                this.setState({
                    avatarUrl: data.avatar.replace('http://10.0.36.105:10683/omas/', 'https://caplos.aircas.ac.cn/ygAvatar/omas'),
                    company: data.company,
                    duty: data.duty,
                    cellphone: data.cellphone,
                })
            } else {
                message.error("用户资料获取失败！");
            }
        }).catch(e => {
            console.log(e)
        })
    }

    changeAvatar = () => {
        document.getElementById('select-img').click()
    }

    uploadImg = (e) => {
        let reader = new FileReader()
        let data = new FormData();
        let nowFile = e.target.files[0];
        if (nowFile.size > 1 * 1024 * 1000) {//    运管接口头像大小限制为1MB
            message.error("请上传大小为1MB以下的图像文件！");
            return;
        }
        data.append('file', e.target.files[0])
        console.log("uploadImg", e.target.files[0])
        this.setState({ avatarFile: e.target.files[0], avatarUrl: URL.createObjectURL(e.target.files[0]) })
        // axios({
        //   method: 'post',
        //   url: global.support.ossUpload + '/oss/upload',
        //   data: data
        // }).then(res => {
        //   console.log(global.support.fileServer + res.data.payload)
        //   this.setState({
        //     avatarUrl: global.support.fileServer + '/' + res.data.payload
        //   })
        // }).catch(e => {
        //   console.log(e)
        // })
    }

    submitInfo = () => {
        const { user } = this.props;
        /* 我们的接口 */
        // let params = {
        //   userId:this.props.user.userId,
        //   email: this.state.eMail,
        //   company: this.state.company,
        //   position: this.state.duty,
        //   cellphone: this.state.cellphone,
        //   avatar: this.state.avatarUrl,
        //   realName: this.state.realName
        // }
        /* ------- */
        /* 北京运管————参数 */
        let params = {
            name: this.props.user.name,
            company: this.state.company,
            duty: this.state.duty,
            cellphone: this.state.cellphone,
            // avatar: this.state.avatarFile,
            // realName: this.state.realName,
        }
        let data = new FormData();
        data.append("userinfo", JSON.stringify(params));
        if (this.state.avatarFile && this.state.avatarFile !== "") data.append("file", this.state.avatarFile);
        /* ------- */
        // let params = {
        //   userinfo: {
        //     name: this.props.user.name,
        //     company: this.state.company,
        //     duty: this.state.duty,
        //     cellphone: this.state.cellphone,
        //     avatar: this.state.avatarFile,
        //   }
        //   // realName: this.state.realName,
        // }
        console.log(user.token)
        axios({
            // url: global.url.sys + '/sys/user/update',
            // url: global.yunguanChangeUrl + '/omas/user/profileImage',
            // url: `/yunguanLoginInfoUrl/omas/user/profileImage`,
            url: global.url.sys + '/yunguan/omas/user/profileImage',
            method: 'post',
            data: data,
            headers: { Authorization: user.token }
        }).then(res => {
            if (res.data.code === 1) {
                // debugger
                message.success("资料修改成功！");
                // store.dispatch(SaveUser(res.data.payload));
                axios.get(global.url.sys + '/yunguan/app/logincheck' + `?token=${user.token}`, null, {
                    withCredentials: false
                }).then(
                    res => {
                        console.log('用户头像获取', global.yunguanAvatar + JSON.parse(res.data.data.userInfo).avatar);
                        // console.log('用户头像获取', global.yunguanAvatar + JSON.parse(res.data.data.userInfo));
                    }
                )

                loadUserLocal(user.token);

            }
            // alert('修改成功！')
            // message.success("资料修改成功！");
            // console.log(res)
            this.props.history.push('/usercenter/myaccount')
        }).catch(err => {
            console.log(err)
        })
    }

    render() {

        // let _email = ''
        // try {
        //   _email = (this.props.user).toJS().username
        // } catch (error) {
        //   console.log(_email)
        // }
        // console.log("this.state.avatarUrl", this.state.avatarUrl);
        return (
            <>
                <div className="changePersonalInfo-content-top">
                    <Link to="/usercenter/myaccount" style={{ display: 'flex' }}>
                        <img className="changePersonalInfo-content-backimg" src={icon_back}></img>
                    </Link>
                    <div className="changePersonalInfo-content-title">资料修改</div>
                </div>
                <div className="changePersonalInfo-main-area-wrap">
                    <div className="changePersonalInfo-wrap">
                        <div className='changePersonalInfo-main'>
                            <div className='changePersonalInfo-avatar-C'>
                                <span>修改头像</span>
                                <div style={{ position: 'relative' }}>
                                    <img src={this.state.avatarUrl} className='changePersonalInfo-avatar' style={{ objectFit: "cover" }}></img>
                                    <div className='changePersonalInfo-avatarBtn-C' onClick={this.changeAvatar}>
                                        <img src={iconCamera} className='changePersonalInfo-avatarBtn'></img>
                                    </div>
                                </div>
                            </div>
                            <input type='file' id="select-img" onChange={(e) => {
                                this.uploadImg(e)
                            }} accept="image/*" style={{ display: "none" }} />
                            <div className='changePersonalInfo-input'>
                                <span>账号</span>
                                <Input value={this.props.user.username} disabled={true}></Input>
                            </div>
                            <div className='changePersonalInfo-input'>
                                <span>真实姓名</span>
                                <Input value={this.props.user.realName} disabled={true}></Input>
                            </div>
                            <div className='changePersonalInfo-input'>
                                <span>手机号码</span>
                                <Input value={this.state.cellphone} onChange={e => {
                                    this.setState({ cellphone: e.target.value })
                                }}></Input>
                            </div>
                            <div className='changePersonalInfo-input'>
                                <span>单位</span>
                                <Input value={this.state.company} onChange={e => {
                                    this.setState({ company: e.target.value })
                                }}></Input>
                            </div>
                            <div className='changePersonalInfo-input'>
                                <span>职称</span>
                                <Input value={this.state.duty} onChange={e => {
                                    this.setState({ duty: e.target.value })
                                }}></Input>
                            </div>
                        </div>
                    </div>
                    <div className="changePersonalInfo-submit-area">
                        <div className='changePersonalInfo-submit'>
                            <Button type='primary' onClick={this.submitInfo}>提交</Button>
                            <Button>重置</Button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapState = (state) => ({
    user: state.userReducer.get('user').toJS()
})


const mapDispatch = dispatch => ({
    SaveUser(param) {
        dispatch(SaveUser(param))
    },
})

export default connect(mapState)(ChangePersonalInfo)
